import { OnoffswitchComponent } from './onoffswitch/onoffswitch';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { PanelSwitchComponent, PanelComponent } from './panel-switch/panel-switch';
import { InputCheckComponent } from './input-check/input-check';
import { InputSwitchComponent } from './input-switch/input-switch';
// import { CollapseModule } from 'ngx-bootstrap/collapse';
// import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    // CollapseModule,
    // BsDropdownModule.forRoot(),
  ],
  declarations: [
    PanelSwitchComponent,
    PanelComponent,
    OnoffswitchComponent,
    InputSwitchComponent,
    InputCheckComponent
  ],
  exports: [
    PanelSwitchComponent,
    PanelComponent,
    OnoffswitchComponent,
    InputSwitchComponent,
    InputCheckComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/components/shared/shared.module.ts